import { Pagination as CssModulesPagination, PaginationProps } from '@sunwebgroup/uds-ui/pagination'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/pagination' instead.
 */
export default Object.assign(
  styled(CssModulesPagination)<PaginationProps>``,
  { displayName: 'Pagination' },
)
